import { useQuery } from '@apollo/client/react';
import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { useBreadcrumbLabel } from '../../components/BreadcrumbLabelsContext.js';
import { assertUuidRouteParams } from '../../lib/assert-uuid-route-params.js';
import { BrandDetailView } from '../../modules/brands/brand-detail.js';
import {
  GET_BRAND,
  type GetBrandQueryResult,
  type GetBrandQueryVariables,
} from '../../modules/brands/operations.js';

export const Route = createFileRoute('/brands/$brandId')({
  beforeLoad: ({ params }) => assertUuidRouteParams(params),
  validateSearch: (search: Record<string, unknown>) => ({
    edit: search.edit === true || search.edit === 'true',
  }),
  component: BrandDetailPage,
});

// eslint-disable-next-line react-refresh/only-export-components
function BrandDetailPage() {
  const navigate = useNavigate();
  const { brandId } = Route.useParams();
  const { edit: startEditing } = Route.useSearch();
  const { data, loading, refetch } = useQuery<GetBrandQueryResult, GetBrandQueryVariables>(
    GET_BRAND,
    { variables: { id: brandId } },
  );
  useBreadcrumbLabel(brandId, data?.brand?.name);

  const setEditingInUrl = (editing: boolean) => {
    void navigate({
      to: '/brands/$brandId',
      params: { brandId },
      search: { edit: editing },
      replace: true,
    });
  };

  return (
    <div>
      {loading ? (
        <div className="text-sm text-muted-foreground">Loading...</div>
      ) : (
        <BrandDetailView
          key={startEditing ? 'edit' : 'view'}
          brand={data?.brand}
          initialEditing={startEditing}
          onChanged={() => void refetch()}
          onEditingChange={setEditingInUrl}
        />
      )}
    </div>
  );
}
